var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageHeroPressFox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 75 32",
    width: 75,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .035156h74.1814v31.9291h-74.1814z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m19.4957 16.0476c0-8.53361 6.8077-15.437328 15.2454-15.437328 8.4057 0 15.1815 6.903718 15.1815 15.437328 0 8.5337-6.7758 15.4372-15.1815 15.4372-8.4377 0-15.2454-6.8717-15.2454-15.4372zm-19.49631035 15.9166v-31.929238h19.14481035l.5752 8.757538h-10.7069v4.1867h8.7572v8.6296h-8.7572v10.3554zm74.18161035-.0957-9.5882-16.4921 8.7571-15.213543h-9.684l-3.8993 6.775823-3.963-6.775823h-9.876l8.8529 15.309543-9.4283 16.3961h9.6841l4.5704-7.9266 4.6345 7.9266zm-36.819-9.4927v-12.65638c0-1.50222-1.1187-2.78074-2.6209-2.78074-1.3743 0-2.557 1.27852-2.557 2.78074v12.65638c0 1.4065 1.1827 2.5888 2.557 2.5888 1.5022 0 2.6209-1.0227 2.6209-2.5888z",
    fill: "#000",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageHeroPressFox);
export default __webpack_public_path__ + "static/media/imageHeroPressFox.a895fa2ae2f8e70fdfbe5a0ad2dd003b.svg";
export { ForwardRef as ReactComponent };